// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"5016c7ad","111":"3aecd8d6","121":"40ec309f","235":"74c8f5ea","276":"48b6307a","496":"0e39b89a","590":"1a285e9a","653":"5c5efbee","708":"091f1178","723":"23c35d7d","824":"d1b3c6bb"}[chunkId] + ".chunk.js";
};